import Lightbox from 'react-lightbox-component';
import { ImageClip } from 'Elements';

export const ReactLightbox = ({ images }, props) => {
	const getImageElements = () => {
		const elements = [];
		images.map((image) => {
			elements.push({
				id: image.file_id,
				src: image?.file_url?.origin,
				title: image.file_title,
				user: image.user,
				size: image?.file_size,
				image
			});
		});
		return elements;
	};

	const renderImageFunc = (idx, image, toggleLightbox) => {
		return (
			<ImageClip
				key={image.id}
				image={image}
				title={image.title}
				user={image.user}
				size={image.size}
				src={image.src}
				onClick={toggleLightbox.bind(null, idx)}
			/>
		);
	};

	return (
		<Lightbox
			images={getImageElements()}
			showImageModifiers={false}
			renderImageFunc={renderImageFunc}
			{...props}
		/>
	);
};
